import { getUtmCookieValues } from '../../cookie/utm';
import { betLocation } from '../../../common/BetLocationContext';

export const mapping = {
    '1': 49,
    X: 88,
    '2': 50,
    '1X': 52,
    '12': 51,
    X2: 53
};

function createBetslipFromLiveBannerAffiliateLink(betId, selection) {
    const selectionCode = mapping[selection] || 49;
    return [
        'CreateDraft',
        null,
        {
            type: 'Standard',
            picks: {
                Standard: [`${betId}-${selectionCode}`]
            },
            positionId: betLocation.THIRD_PARTY_LIVE_BANNER.id,
            positionCode: betLocation.THIRD_PARTY_LIVE_BANNER.code,
            retainPicks: true,
            utmTags: getUtmCookieValues()
        }
    ];
}

export function getStartingCommand() {
    const params = new URL(document.location).searchParams;
    const betId = params.get('betId');
    const selection = params.get('selection');

    if (betId && parseInt(betId) && selection) {
        return createBetslipFromLiveBannerAffiliateLink(betId, selection);
    }
    return ['ReadBetslips', null, {}];
}
